module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/211-poland-56fbe8131aef76256e519424eee5f40c.svg";